import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Spin, Tabs } from "antd";
import DineIn from "./components/DineIn";
import PickupDelivery from "./components/PickupDelivery";
import { useGetSettingsMutation } from "redux/settings/settingsSlice";
import { UTILS } from "utils";
import useAllStores from "hooks/useCurrentUserStores";
import { Link } from "react-router-dom";
import { CONSTANTS as C } from "config";
import html2canvas from "html2canvas";
import AppContainer from "components/ui/AppContainer";
import AppSimpleText from "components/ui/AppSimpleText.jsx";
import AppSwitch from "components/ui/AppSwitch.jsx";
const { TabPane } = Tabs;

const Index = () => {
  const { t } = useTranslation();
  const { stores, loading } = useAllStores();
  const [settings, setSettings] = useState();
  const [orderPageLink, setOrderPageLink] = useState();
  const [getSettings] = useGetSettingsMutation();
  const fetchSettings = async () => {
    const userDetail = UTILS.getCurrentUser();
    const obj = {
      brandId: userDetail.brandId,
    };
    const { data } = await getSettings(obj);
    if (data?.success === 1 && data?.data) {
      setSettings(data.data);
    }
  };
  useEffect(() => {
    fetchSettings();
    const userDetail = UTILS.getCurrentUser();
    const text = userDetail.storeFrontURL + userDetail?.temporaryDomainName;
    setOrderPageLink(text);
  }, []);

  const [qrCodeSetting, setQrCodeSetting] = useState({
    innerColor: null,
  });

  const handleColorSettings = (enabled) => {
    setQrCodeSetting((prev) => {
      if (enabled) {
        const raw = settings?.setting?.color;
        if (!raw) {
          return prev;
        }
        const innerColor = String(raw).replace(/^#/, "");
        return { ...prev, innerColor };
      }
      return { ...prev, innerColor: null };
    });
  };

  const handleDownload = (ID) => {
    const el = document.getElementById(ID);
    if (!el) return;

    html2canvas(el, {
      useCORS: true,
      allowTaint: false,
      backgroundColor: "#ffffff",
      scale: 2,
    })
      .then(function (canvas) {
        const link = document.createElement("a");
        link.download = "qrcode.png";
        link.href = canvas.toDataURL("image/png");
        link.click();
      })
      .catch(() => {
        UTILS.errorNotification(
          t("Unable to download QR with logo. Please ensure logo URL allows CORS access.")
        );
      });
  };

  const EditBranding=()=>{
    return(
      <div className="flex-col items-center w-full  p-2 justify-between">
            {/* add note  */}
            
            <div className="flex justify-between items-center pt-1">
              <h2 className="text-gray-900  text-17px font-semibold">
                {t("Customization")}
              </h2>
              
               
            </div>
            <div className="flex flex-col md:flex-row items-center w-full ">
                <div className="mr-auto">
                  <AppSwitch
                    label={t("Use business colors")}
                    checked={Boolean(qrCodeSetting?.innerColor)}
                    onChange={handleColorSettings}
                  />
                </div>
                <Link
                to="/app/dashboard/settings/branding"
                className=" md:ml-auto my-3 md:my-0 inline-flex items-center rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-normal text-gray-700 hover:bg-gray-50"
              >
                {t("Edit Branding")}
              </Link>

              </div>
              <AppSimpleText>
              {t(
                "When using branding in QR codes, always verify that they are scanning well before printing"
              )}
            </AppSimpleText>
            {/* <div className="pb-3 flex">
              <RadioButton
                label={t("Use business colors")}
                value={qrCodeSetting?.innerColor}
                keyVal={"color"}
                handleValues={handleColorSettings}
              />
            </div> */}
          </div>
    )
  }

  return (
    <AppContainer title={t("QR codes for your Digital Menu")} subTitle={t("Create a QR code with your ordering page and advertise it on offline places like diner tables and counters, packaging, banners, and more")} loading={loading}>
      <div className="mt-5">
        <Tabs defaultActiveKey="1" onChange={() => {}}>
         
          <TabPane
            tabBarStyle="color: pink;"
            tab={t("Pickup & Delivery")}
            key="1"
          >
            {<EditBranding/>}
            <PickupDelivery
              {...{ settings, orderPageLink, qrCodeSetting, handleDownload }}
            />
          </TabPane>
          {UTILS.getCatalogueType() !== C.BRAND_BASED && (
            <TabPane tab={t("DINEIN")} key="2">
              {<EditBranding/>}
              <DineIn
                {...{
                  settings,
                  orderPageLink,
                  stores,
                  qrCodeSetting,
                  handleDownload,
                }}
              />
            </TabPane>
          )}
        </Tabs>
      </div>
    </AppContainer>
    // <Spin spinning={loading}>
    //   <div className="px-4 lg:px-8 py-4">
    //     <h1 className="text-gray-900 text-24px md:text-30px font-medium">
    //       {t("QR codes for your Digital Menu")}
    //     </h1>
    //     <h3 className="text-gray-500 pt-2 pb-4">
    //       {t(
    //         "Create a QR code with your ordering page and advertise it on offline places like diner tables and counters, packaging, banners, and more"
    //       )}
    //     </h3>
    //     <div className="flex-col items-center w-full lg:w-1/2 p-4 justify-between border border-gray-200">
    //       {/* add note  */}
    //       <div className="text-red-600 font-bold text-14px ">
    //         {t(
    //           "When using branding in QR codes, always verify that they are scanning well before printing"
    //         )}
    //       </div>
    //       <div className="flex justify-between items-center pt-8">
    //         <h2 className="text-gray-900  text-17px font-semibold">
    //           {t("Customization")}
    //         </h2>
    //         <Link
    //           to="/app/dashboard/settings/branding"
    //           className="text-blue-500 ant-btn ant-btn-defualt ant-btn-lg mx-2"
    //         >
    //           {t("Edit Branding")}
    //         </Link>
    //       </div>

    //       <div className="pb-3 flex">
    //         <RadioButton
    //           label={t("Use business colors")}
    //           value={qrCodeSetting?.innerColor}
    //           keyVal={"color"}
    //           handleValues={handleColorSettings}
    //         />
    //       </div>
    //     </div>
    //     <div className="mt-5">
    //       <Tabs defaultActiveKey="1" onChange={() => {}}>
    //         <TabPane
    //           tabBarStyle="color: pink;"
    //           tab={t("Pickup & Delivery")}
    //           key="1"
    //         >
    //           <PickupDelivery
    //             {...{ settings, orderPageLink, qrCodeSetting, handleDownload }}
    //           />
    //         </TabPane>
    //         {UTILS.getCatalogueType() !== C.BRAND_BASED && (
    //           <TabPane tab={t("DINEIN")} key="2">
    //             <DineIn
    //               {...{
    //                 settings,
    //                 orderPageLink,
    //                 stores,
    //                 qrCodeSetting,
    //                 handleDownload,
    //               }}
    //             />
    //           </TabPane>
    //         )}
    //       </Tabs>
    //     </div>
    //   </div>
    // </Spin>
  );
};

export default Index;
